const FIELDTYPECONSTANTS = {
    DROPDOWN: "dropdown",
    RADIO: "radio",
    TEXTAREA: "textarea",
    TEXT: "text",
    BUTTON: "button"
};

export default FIELDTYPECONSTANTS;